/* eslint-disable eag/match-named-export, eag/no-index -- Pre-existing grab-bag file with several exports. Pre-existing violation */
import {foundationTheme} from 'platform/foundation';

const IMAGE_WIDTH_STEPS = 58;

export const prepareVehicleAlbumImageUrl = (url: string) => {
  const queryDelimiter = url?.includes('?') ? '&' : '?';
  // width query param expects pixels; converts step units to px via theme
  return `${url}${queryDelimiter}width=${IMAGE_WIDTH_STEPS * (foundationTheme.space.step * 16)}`;
};

export const VEHICLE_ALBUM_IMAGE_SIZE = {
  width: IMAGE_WIDTH_STEPS,
  height: 43,
} as const;
